import { render, staticRenderFns } from "./CompanyFollowers.vue?vue&type=template&id=33a38230&scoped=true"
import script from "./CompanyFollowers.vue?vue&type=script&lang=js"
export * from "./CompanyFollowers.vue?vue&type=script&lang=js"
import style0 from "./CompanyFollowers.vue?vue&type=style&index=0&id=33a38230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a38230",
  null
  
)

export default component.exports